import React, {ReactElement} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch} from "../../app/hooks";
import Skeleton from "react-loading-skeleton";
import {CheckmarkIcon, RadioEmptyIcon, RadioFilledIcon} from "../icons";
import {Body, LocalizedTextLabel, Paragraph} from "../text";
import {LocalizationInfo} from "react-i18next";

export class MacroSurveyOptionItem {
  title: string | LocalizationInfo = ''
  id: string = ''
  subtitle?: string | LocalizationInfo
  isSelected: boolean = false
}

interface MacroSurveyOptionItemViewProps {
  item: MacroSurveyOptionItem
  icon?: React.ReactNode
  isLoading: boolean
  onItemSelected: ((item: MacroSurveyOptionItem) => void)
}

export const MacroSurveyOptionItemView: React.FC<MacroSurveyOptionItemViewProps> = ({ item, isLoading, icon, onItemSelected }) => {
  const { t } = useTranslation()

  const iconProps = icon && (icon as ReactElement)?.props
  const iconClassName = `${iconProps?.className ? iconProps.className : ''} h-8 w-8 lg:h-9 lg:w-9`

  return <div
    className={`flex flex-row items-center space-x-4 px-5 hover:bg-fg-gray-surface-light transition-colors lg:space-x-6 py-5 cursor-pointer border-b last:border-0 border-fg-gray-surface w-full`}
    onClick={() => {
      onItemSelected(item)
    }}
  >
    <div className="flex-shrink-0">
      {icon && React.cloneElement(icon as React.ReactElement, { className: iconClassName })}
    </div>

    <div className="flex-grow">
      <Body className={`${item.subtitle ? 'mb-1' : ''}`}>
        {isLoading ? <Skeleton className="!w-3/4"/> : <LocalizedTextLabel t={t} text={item.title}/>}
      </Body>
      <Paragraph className={`${item.subtitle ? 'block' : 'hidden'} text-fg-gray-dark`}>
        {isLoading ? <Skeleton className="!w-1/3"/> : <LocalizedTextLabel t={t} text={item.subtitle}/>}
      </Paragraph>
    </div>

    <div className="flex-shrink-0">
      {
        (() => {
          if (isLoading) {
            return <Skeleton className="!rounded-full !h-7 !w-7 !mx-1.5" />
          } else if (item.isSelected) {
            return <CheckmarkIcon className="text-fg-primary h-6 w-6 mx-2" />
          } else {
            return <CheckmarkIcon className="text-transparent h-6 w-6 mx-2" />
          }
        })()
      }
    </div>
  </div>
}